import React from "react";
import "./SocialMediaManagement.css";

const SocialMediaManagement = () => {
  return (
    <div>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
      <p>This is SocialMediaManagement</p>
    </div>
  );
};

export default SocialMediaManagement;
